import React, { FunctionComponent } from 'react';
import { LeavesDescription } from './LeavesDescription';
import { RulesAndTemplates } from './RulesAndTemplates';
import './HelpPage.scss';
import { useUsageStatistics } from '../../utils/hooks';
import apiConfig from '../../api/routes';

export const HelpPage: FunctionComponent = () => {

  useUsageStatistics(apiConfig.statisticsUsageService.helpPage);

  return (
    <div className='help'>
      <LeavesDescription />
      <RulesAndTemplates />
    </div>
  );
};
